// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 647 ? "ca377847" : chunkId) + "." + {"52":"eb0b98fde370268b","647":"c966eab8e18c3e7b","757":"a84346d902530163"}[chunkId] + ".js";
};